/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
(function ($) {
  function showMoreCategories() {
    var cats = $(".product-meta__reference.product-collections");
    if (cats.length > 0 && cats.height() > 52) {
      cats.after('<span class="show-more">See all</span>');
      cats.addClass("minimized");

      $(document).on("click", ".minimized + .show-more", function (e) {
        e.preventDefault();
        $(this).text("See less");
        cats.addClass("maximized");
        cats.removeClass("minimized");
      });
      $(document).on("click", ".maximized + .show-more", function (e) {
        e.preventDefault();
        $(this).text("See all");
        cats.addClass("minimized");
        cats.removeClass("maximized");
      });
    }
  }
  showMoreCategories();

  function categoryDescription() {
    if ($("body").hasClass("template-collection")) {
      setTimeout(function () {
        if (window.innerWidth < 640) {
          $("#gf_pagination_wrap").after($(".collection__description"));
        } else {
          $(".collection__meta").after($(".collection__description"));
        }
      }, 1);
    }
  }

  var header = {
    isMobile: function () {
      if (window.innerWidth > 640) {
        return false;
      } else {
        return true;
      }
    },
    desktopHeader: {
      hide: function () {
        $("body").addClass("bar-hide");
        $("body").removeClass("bar-show");
        $(".infobox").addClass("hideThis");
        if ($("#mini-cart").hasClass("inactive")) {
          $(".header.header.header--inline.header--search-expanded").addClass(
            "hideThis"
          );
        }
      },
      show: function () {
        $("body").removeClass("bar-hide");
        $("body").addClass("bar-show");
        $(".infobox").removeClass("hideThis");
        $(".header.header.header--inline.header--search-expanded").removeClass(
          "hideThis"
        );
      },
    },
    mobileHeader: {
      hide: function () {
        $("body").addClass("bar-hide");
        $("body").removeClass("bar-show");
        if ($("#mini-cart").hasClass("inactive")) {
          $(".header.header.header--inline.header--search-expanded").addClass(
            "hideThis"
          );
        }
      },
      show: function () {
        $("body").removeClass("bar-hide");
        $("body").addClass("bar-show");
        $(".header.header.header--inline.header--search-expanded").removeClass(
          "hideThis"
        );
      },
    },
    hide: function () {
      var self = this;
      if (self.isMobile()) {
        self.mobileHeader.hide();
      } else {
        self.desktopHeader.hide();
      }
    },
    show: function () {
      var self = this;
      if (self.isMobile()) {
        self.mobileHeader.show();
      } else {
        self.desktopHeader.show();
      }
    },
  };

  var lastScrollTop = 0;
  window.scroll(function () {
    var scroll = window.scrollTop();

    if (Math.abs(lastScrollTop - scroll) > 200) {
      if ((scroll > lastScrollTop) & (scroll >= 42)) {
        // downscroll code
        header.hide();
      } else if (scroll < lastScrollTop || scroll >= 42) {
        // upscroll code
        header.show();
      }

      lastScrollTop = scroll;
    }
  });

  function closeCart() {
    $(document).on("click", ".mini-cart", function (e) {
      if ($(e.target).hasClass("mini-cart")) {
        $('[data-action="toggle-mini-cart"]')[0].click();
      }
    });
    $(document).on("scroll", function () {
      if ($(".mini-cart").attr("aria-hidden") == "false") {
        $('[data-action="toggle-mini-cart"]')[0].click();
      }
    });
  }
  function atl() {
    //if($('body').hasClass('template-cart')){

    //$( '[name="attributes[Authority To Leave]"]' ).prop( "checked", false );
    $(document).on("click", ".atl_box_button", function (e) {
      $(".atl_box_button").removeClass("active");
      $(e.currentTarget).addClass("active");
      if ($(e.currentTarget).hasClass("yes")) {
        $('[name="attributes[Authority To Leave]"]').prop("checked", true);
        setCookie("atl", true, 30);
      } else {
        $('[name="attributes[Authority To Leave]"]').prop("checked", false);
        setCookie("atl", false, 30);
      }
    });
    //}
  }

  function stampedGoToReviews() {
    if ($("body").hasClass("template-product")) {
      $(document).on("click", ".stamped-product-reviews-badge", function (e) {
        e.preventDefault;
        if (!$('.tabs-titles [href="#reviews"]').hasClass("active")) {
          console.log("clicked");
          // $('.tabs-titles [href="#reviews"]').trigger('click');
          $(".tab-content").removeClass("active");
          $(".tabs-titles a").removeClass("active");
          $('.tabs-titles a[href="#reviews"]').addClass("active");
          $("#reviews").addClass("active");

          StampedFn.pageReviews("1", "", this);

          $("#reviews").trigger("click");
          setTimeout(
            $("html, body").animate(
              {
                scrollTop: $("#reviews").offset().top - 300,
              },
              1000
            ),
            2000
          );
          // $('#reviews').trigger('click');
        }
        // $('#reviews').trigger('click');
        // setTimeout(
        //     $('html, body').animate({
        //         scrollTop: $("#reviews").offset().top - 300
        //     }, 1000),1000);
      });
    }
  }
  function handleAddToCartDisabled() {
    $(document).on(
      "click",
      '.template-product [name="add"].button--disabled',
      function (e) {
        e.preventDefault();
        console.log("clicked");
        $(".add-to-cart-notice").addClass("active");
      }
    );
  }

  handleAddToCartDisabled();
  //afterpayCalc();
  // closeCart();
  // atl();
  stampedGoToReviews();

  //categoryDescription();
  function loadMoreButton() {
    if ($("body").hasClass("template-collection")) {
      var canonical = window.location.href;
      $('link[rel="canonical"]').attr("href", canonical);
    }

    $(document).on(
      "click",
      ".template-collection .gf-loadmore-btn",
      function (e) {
        setTimeout(function () {
          // update canonical
          var canonical = window.location.href;
          $('link[rel="canonical"]').attr("href", canonical);
        }, 1000);
      }
    );
  }
  loadMoreButton();
})(jQuery);

// Stamped reviews

document.addEventListener("DOMContentLoaded", (event) => {
  setTimeout(() => {
    const stampedReviewsWidget = document.getElementById('stamped-reviews-widget');

    if (stampedReviewsWidget) {
      // Get the first 12 reviews, for performance reasons
      const firstTwelveReviews = stampedReviewsWidget.querySelectorAll('#stamped-carousel-scroll-wrapper .block:nth-child(-n+12)');

      let maxCharacters = '';
      if (window.innerWidth >= 768) {
        maxCharacters = stampedReviewsWidget.getAttribute('data-max-characters-desktop');
      } else {
        maxCharacters = stampedReviewsWidget.getAttribute('data-max-characters-mobile');
      }
      
      if (firstTwelveReviews && maxCharacters !== '') {
        firstTwelveReviews.forEach(review => {
          const reviewContent = review.querySelector('.stamped-reviews-message-block');
          if (reviewContent) {
            if (reviewContent.innerText.length > maxCharacters) {
              reviewContent.innerText = reviewContent.innerText.substring(0, maxCharacters) + '...';
            }
          }
        });
      }
    }
  }, 5000);
});

// Product page - Truncated product description

document.addEventListener("DOMContentLoaded", function() {
  var divFullDescription = document.querySelector(".full-product-description");
  
  if (divFullDescription) {
    var fullDescription = divFullDescription.innerHTML;
    var charLimit = 1200;

    if (fullDescription.length > charLimit) {
      var truncatedDescription = fullDescription.substring(0, charLimit) + '...';
      divFullDescription.innerHTML = truncatedDescription;
    }
  };
});

/* Page Account - Overview */

// Hide the word "BrewPoints" in the display of the number of points

const targetNode = document.getElementById('stamped-rewards-widget');

if (targetNode) {
  const config = { childList: true, subtree: true };

  const callback = function(mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const stampedPointBalance = document.querySelector('.stamped-rewards-widget-points.stamped-point-balance');
        if (stampedPointBalance) {
          stampedPointBalance.textContent = stampedPointBalance.textContent.replace(' BrewPoints', '');
          
          const helpLink = document.createElement('a');
          helpLink.href = '/pages/loyalty-and-rewards';
          helpLink.textContent = 'What is BrewPoints?';
          helpLink.style.display = 'block';
          helpLink.classList.add('text-accent', 'rewards-help-link');

          stampedPointBalance.insertAdjacentElement('afterend', helpLink);

          observer.disconnect();
          break;
        }
      }
    }
  };

  const rewardsObserver = new MutationObserver(callback);

  rewardsObserver.observe(targetNode, config);
}


/* Accelarated payment method buttons located in the cart drawer are hard to style due to shadow DOM and limited CSS properties (https://shopify.dev/docs/storefronts/themes/pricing-payments/accelerated-checkout/upgrade-accelerated-checkout).
This script is a workaround to apply a dynamic width to these buttons.
This dynamic width is equal to the cart drawer's width minus its padding. */

function applyButtonWidth() {
  const widthElement = document.querySelector('.cart__main-content-wrapper .after-form');

  if (widthElement) {
      const originalWidth = widthElement.offsetWidth;
      const adjustedWidth = originalWidth - 30; // Subtract 30 pixels of padding
      
      if (adjustedWidth > 0) {
        const elementsToResize = document.querySelectorAll('shopify-accelerated-checkout-cart > *');

        elementsToResize.forEach((element) => {
          element.style.width = adjustedWidth + 'px';
        });
      } else {
          setTimeout(applyButtonWidth, 100);
      }
  } else {
      console.error("Width element not found.");
  }
}

function dynamicPaymentObserver() {
  const targetNode = document.getElementById('dynamic-checkout-cart');

  if (targetNode) {
    const paymentObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          applyButtonWidth();
          paymentObserver.disconnect();
        }
      });
    });

    paymentObserver.observe(targetNode, { childList: true, subtree: true });
  }
}

dynamicPaymentObserver();

/**
 * Product PDP: on mobile, move “Need Help?” tel link before Shopify “More payment options” when present;
 * otherwise keep it under the add-to-cart button (see snippets/product-info.liquid).
 */
(function () {
  var mqMobile = window.matchMedia('(max-width: 640px)');
  var scheduled = null;

  function schedulePlaceProductHelpCallLinks() {
    if (scheduled) {
      clearTimeout(scheduled);
    }
    scheduled = setTimeout(function () {
      scheduled = null;
      placeProductHelpCallLinks();
    }, 50);
  }

  function placeProductHelpCallLinks() {
    document.querySelectorAll('.js-product-help-call').forEach(function (link) {
      var container = link.closest('[data-product-help-scope]');
      if (!container) {
        return;
      }
      var home = container.querySelector('.add-to-cart-group');
      if (!home) {
        return;
      }
      var moreAnchor = container.querySelector(
        'more-payment-options-link a.shopify-payment-button__more-options'
      );
      var mobile = mqMobile.matches;

      if (mobile && moreAnchor && document.body.contains(moreAnchor)) {
        if (link.nextElementSibling === moreAnchor) {
          return;
        }
        moreAnchor.insertAdjacentElement('beforebegin', link);
      } else {
        if (link.parentElement === home) {
          return;
        }
        home.appendChild(link);
      }
    });
  }

  function initProductHelpCallPlacement() {
    placeProductHelpCallLinks();
    document.querySelectorAll('[data-product-help-scope]').forEach(function (container) {
      var obs = new MutationObserver(schedulePlaceProductHelpCallLinks);
      obs.observe(container, { childList: true, subtree: true });
    });
    window.addEventListener('resize', schedulePlaceProductHelpCallLinks);
    if (mqMobile.addEventListener) {
      mqMobile.addEventListener('change', schedulePlaceProductHelpCallLinks);
    } else if (mqMobile.addListener) {
      mqMobile.addListener(schedulePlaceProductHelpCallLinks);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductHelpCallPlacement);
  } else {
    initProductHelpCallPlacement();
  }
})();
